import { all, takeEvery, put } from 'redux-saga/effects';
import { logPageView, biModalUnload } from '@wix/da-shared-react/pkg/biLogger/redux/actions';
import { appMounted } from '../actions/app';
import { exitDuperbrowseDone } from '@wix/da-shared-react/pkg/Duperbrowse/redux/actionCreators';

export function* pageViewHandler({ payload }) {
  if (typeof payload === 'object' && payload !== null) {
    const { pageName, biComponent } = payload;
    yield put(
      logPageView({
        component: biComponent,
        view: pageName,
      })
    );
    return;
  }

  yield put(
    logPageView({
      component: 'misc_page',
      view: 'misc',
    })
  );
}

export default function* biLogger() {
  yield all([takeEvery([appMounted, exitDuperbrowseDone, biModalUnload], pageViewHandler)]);
}
